import { Typography, Space } from 'antd';

const { Title } = Typography;

interface PageShellProps {
  title: string;
  extra?: React.ReactNode;
  filters?: React.ReactNode;
  children: React.ReactNode;
  fullHeight?: boolean;
  hideHeader?: boolean;
}

export function PageShell({ title, extra, filters, children, fullHeight = false, hideHeader = false }: PageShellProps) {
  return (
    <div
      style={
        fullHeight
          ? { display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }
          : undefined
      }
    >
      {/* Page header */}
      {!hideHeader && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: filters ? 8 : 16,
            flexWrap: 'wrap',
            gap: 8,
          }}
        >
          <Title level={4} style={{ margin: 0 }}>
            {title}
          </Title>
          {extra && <Space wrap>{extra}</Space>}
        </div>
      )}

      {/* Filters row */}
      {filters && <div style={{ marginBottom: 12 }}>{filters}</div>}

      {/* Page content */}
      <div style={fullHeight ? { display: 'flex', flexDirection: 'column', minHeight: 0, flex: 1 } : undefined}>
        {children}
      </div>
    </div>
  );
}
